var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStyleNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.173828C18.6274 0.173828 24 5.54641 24 12.1738C24 18.8012 18.6274 24.1738 12 24.1738C5.37258 24.1738 0 18.8012 0 12.1738C0 5.54641 5.37258 0.173828 12 0.173828ZM19.5431 6.39789L6.22407 19.7169C7.82463 20.9443 9.82712 21.6738 12 21.6738C17.2467 21.6738 21.5 17.4205 21.5 12.1738C21.5 10.0009 20.7705 7.99846 19.5431 6.39789ZM12 2.67383C6.75329 2.67383 2.5 6.92712 2.5 12.1738C2.5 14.3467 3.2295 16.3492 4.45694 17.9498L17.7759 4.63076C16.1754 3.40332 14.1729 2.67383 12 2.67383Z",
    fill: "#97A1CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStyleNone);
export default __webpack_public_path__ + "static/media/icon_style_none.4409ada5.svg";
export { ForwardRef as ReactComponent };